export default "__VITE_ASSET__DjcR9utr__"